module.exports = __webpack_public_path__ + "static/media/fullRoomOne.b34fb461.png";